import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../environments/environment';
import { Constantes } from '../../shared/constantes';
import { Mensaje } from '../../shared/models/mensaje';

@Injectable()
export class DetalleService {
  api: string;
  servicio: string;

  constructor(private httpClient: HttpClient) {
    this.api = environment.api;
    this.servicio = Constantes.SERVICIO;
  }

  consultarDetalleSolicitud(idSolicitud: number, autorizacion: string): Observable<Mensaje> {
    const options = { params: new HttpParams().set('autorizacion', autorizacion) };

    return this.httpClient.get<Mensaje>(this.api + this.servicio + 'detalle/' + idSolicitud, options);
  }

  consultarTransaccionesPse(idSolicitud: number): Observable<Mensaje> {
    return this.httpClient.get<Mensaje>(this.api + this.servicio + 'detalle/transaccionesPse/' + idSolicitud);
  }

  crearTransaccionPse(idSolicitud: number, queryParamsRetorno: string): Observable<Mensaje> {
    const options = { params: new HttpParams().set('params', queryParamsRetorno) };

    return this.httpClient.get<Mensaje>(this.api + this.servicio + 'detalle/transaccion/' + idSolicitud, options);
  }

  estaSolicitudPaga(idSolicitud: number, consultaPse: boolean): Observable<boolean> {
    return this.httpClient.get<boolean>(this.api + this.servicio + 'detalle/estaSolicitudPaga/' + consultaPse + '/' + idSolicitud);
  }

  getReporte(idSolicitud: number, sinInfoExterna: string): Observable<Blob> {
    return this.httpClient.get<Blob>(this.api + this.servicio + 'detalle/reporte/' + sinInfoExterna  + '/' + idSolicitud, { responseType: 'blob' as 'json' });
  }

  getMensaje(idSolicitud: number, codigoMensaje: string): Observable<string> {
    return this.httpClient.get<string>(this.api + this.servicio + 'detalle/mensaje/' + codigoMensaje + '/' + idSolicitud);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/core/services/detalle.service.ts